import React from 'react';
import { Box, Grid, Button, Skeleton, makeStyles, LottiePlayerECOMMBX } from '@dxb-web-ui-framework/design-system';
import { TFunction } from 'react-i18next';
import { SkeletonTypography } from '../../../../../content-composer/src/components/Generic/Skeleton';

export interface RequestDealerRateSuccessInfoProps {
  isLoading: boolean;
  isMobile: boolean;
  onBack: () => void;
  t: TFunction;
}

const useStyles = makeStyles(theme => ({
  img: {
    width: '100%',
    height: '100%',
    maxWidth: '416px',
    maxHeight: '416px',
    margin: 'auto',
    padding: theme.spacing(5),
    [theme.breakpoints.down('sm')]: { padding: theme.spacing(10) },
  },
  title: { color: theme.palette.success.main, [theme.breakpoints.down('sm')]: { textAlign: 'center' } },
  text: { marginTop: theme.spacing(2), [theme.breakpoints.down('sm')]: { textAlign: 'center' } },
}));

const RequestDealerRateSuccessInfo = ({ isLoading, onBack, isMobile, t }: RequestDealerRateSuccessInfoProps) => {
  const classes = useStyles();

  if (isMobile) {
    return (
      <Box display='flex' flexDirection='column' p={3}>
        <SkeletonTypography hasSkeleton={isLoading} typographyProps={{ variant: 'h4', className: classes.title }}>
          {t('fundsTransferPage.TransferFlow.SuccessStepDealerRate.title')}
        </SkeletonTypography>
        <SkeletonTypography
          hasSkeleton={isLoading}
          typographyProps={{ color: 'textSecondary', className: classes.text }}>
          {t('fundsTransferPage.TransferFlow.SuccessStepDealerRate.text')}
        </SkeletonTypography>
        <Box display='flex' mt={isLoading ? 2 : 0} flex={1} justifyContent='center' alignItems='center'>
          {isLoading ? (
            <Skeleton width='100%' height='100%'>
              <LottiePlayerECOMMBX icon='ecommbx_success' loop play />
            </Skeleton>
          ) : (
            <LottiePlayerECOMMBX icon='ecommbx_success' loop play />
          )}
        </Box>
        <Box display='flex' justifyContent='center'>
          <Box mt={3} maxWidth='210px' width='100%'>
            <Button color='primary' size='large' variant='contained' fullWidth onClick={onBack} hasSkeleton={isLoading}>
              {t('fundsTransfer.SuccessStep.Button.primary')}
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Grid container justifyContent='space-between'>
      <Grid container item xs={12} md={isLoading ? 4 : 6} direction='column' justifyContent='center'>
        <SkeletonTypography hasSkeleton={isLoading} typographyProps={{ variant: 'h3', className: classes.title }}>
          {t('fundsTransferPage.TransferFlow.SuccessStepDealerRate.title')}
        </SkeletonTypography>
        <SkeletonTypography
          hasSkeleton={isLoading}
          typographyProps={{ color: 'textSecondary', className: classes.text }}>
          {t('fundsTransferPage.TransferFlow.SuccessStepDealerRate.text')}
        </SkeletonTypography>
        <Box textAlign='center' maxWidth='210px' width='100%'>
          <Box mt={6}>
            <Button color='primary' size='large' variant='contained' fullWidth onClick={onBack} hasSkeleton={isLoading}>
              {t('fundsTransfer.SuccessStep.Button.primary')}
            </Button>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box
          width='100%'
          height='100%'
          mt={isLoading ? 2 : 0}
          display='flex'
          justifyContent='center'
          alignItems='center'>
          {isLoading ? (
            <Skeleton width='100%' height='100%'>
              <LottiePlayerECOMMBX icon='ecommbx_success' loop play />
            </Skeleton>
          ) : (
            <LottiePlayerECOMMBX icon='ecommbx_success' loop play />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export { RequestDealerRateSuccessInfo };
